var newsList = {
	noResults: "Aucun résultat trouvé",
	readMore: "Lire la suite",
	estimatedReadingTime: "~{minutes} min de lecture"
};
var fr = {
	newsList: newsList
};

export { fr as default, newsList };
